var React = require('react');

function Orders (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 16C5.10457 16 6 16.8954 6 18C6 19.1046 5.10457 20 4 20C2.89543 20 2 19.1046 2 18C2 16.8954 2.89543 16 4 16ZM9 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H9C8.44771 19 8 18.5523 8 18C8 17.4477 8.44771 17 9 17ZM4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10ZM9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11ZM4 4C5.10457 4 6 4.89543 6 6C6 7.10457 5.10457 8 4 8C2.89543 8 2 7.10457 2 6C2 4.89543 2.89543 4 4 4ZM9 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H9C8.44771 7 8 6.55228 8 6C8 5.44772 8.44771 5 9 5Z","fill":"#414141"}));
}

Orders.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Orders;

Orders.default = Orders;
